import { apiClient, getAuthHeader } from "./apiConfig";

export const createSubscription = async (payload) => {
  const res = await apiClient.post(`/subscriptions/create`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data?.data || null;
};

export const fetchSubscriptionByToken = async (token) => {
  const res = await apiClient.get(`/subscriptions/by-token/${token}`);
  return res.data?.data || null;
};

export const fetchSubscriptions = async (params = {}) => {
  const res = await apiClient.get(`/subscriptions/get_all`, {
    ...getAuthHeader(),
    params,
  });
  return res.data?.data || [];
};

export const fetchMySubscription = async () => {
  const res = await apiClient.get(`/subscriptions/mine`, getAuthHeader());
  return res.data?.data || { access_state: "none", required: true, subscription: null };
};

export const assignSubscriptionUser = async (id, userId) => {
  const res = await apiClient.post(
    `/subscriptions/assign-user/${id}`,
    { user_id: userId },
    getAuthHeader()
  );
  return res.data;
};

export const updateSubscriptionAccess = async (id, accessStatus) => {
  const res = await apiClient.post(
    `/subscriptions/update-access/${id}`,
    { access_status: accessStatus },
    getAuthHeader()
  );
  return res.data;
};
